export default __webpack_public_path__ + "static/media/exclamationMark.67bce00b.svg";